export const SHOW_NOTIFICATION = 'notifier/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'notifier/HIDE_NOTIFICATION';